import ActiveDirectory from './active-directory';

export { ActiveDirectory };

export default ActiveDirectory;
